import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import OverallRating from '../home-content/overall-rating';
import Reviews from '../home-content/reviews';

const ClientReviews = (props: any) => {
  const { ratingData } = props;
  const [reviewsAll, setReviewsAll] = useState([]);

  const [rating, setRating] = useState(0);
  const [numberOfReviews, setNumberOfReviews] = useState(0);
  useEffect(() => {
    setReviewsAll(ratingData?.highlightedReviews);

    setRating(ratingData?.averageRating);
    setNumberOfReviews(ratingData?.numberOfReviews);
  }, [ratingData]);
  return (
    <div>
      {reviewsAll && reviewsAll?.length ? (
        <section id="client-reviews-google" className="reviews">
          <div className="container">
            <h2 className="section-heading">
              <FormattedMessage id="client-reviews" />
            </h2>
            <div className="review-cards d-none d-lg-block d-md-none">
              <div className="row justify-content-center g-3">
                {reviewsAll?.map(
                  (data: any, index: any) =>
                    index < 3 && (
                      <Reviews key={data?.name} data={data}></Reviews>
                    )
                )}
              </div>
            </div>

            <div className="review-cards  d-none d-lg-none d-md-block">
              <div className="row justify-content-center g-3">
                {reviewsAll?.map((data: any, index: any) => {
                  return (
                    index < 2 && (
                      <Reviews key={data?.name} data={data}></Reviews>
                    )
                  );
                })}
              </div>
            </div>

            <div className="review-cards d-block d-lg-none d-md-none">
              <div className="row justify-content-center g-3">
                {reviewsAll?.map((data: any, index: any) => {
                  return (
                    index === 0 && (
                      <Reviews key={data?.name} data={data}></Reviews>
                    )
                  );
                })}
              </div>
            </div>
            <OverallRating
              rating={rating}
              numberOfReviews={numberOfReviews}
            ></OverallRating>
          </div>
        </section>
      ) : null}
    </div>
  );
};

export default ClientReviews;
